import { DEVELOPMENT } from '../../env'
import { isSSR } from '../IsSSR'

let promise: Promise<string> | null = null

const defaultCountry = 'US'

export async function fetchCountry(): Promise<string> {
  if (DEVELOPMENT || isSSR) {
    return defaultCountry
  }

  if (promise) {
    return promise
  }

  promise = fetch('https://get.geojs.io/v1/ip/country', {
    referrerPolicy: 'no-referrer',
  })
    .then((response) => response.text())
    .then((text) => text.trim())
    .then((country) => (country.length === 2 ? country : Promise.reject()))
    .catch(() => defaultCountry) // this function must return some country code to be able to show advertising

  return promise
}
